module.exports = __webpack_public_path__ + "img/pd-img4.6bb9a695.png";